// Func = limiting Scope for this file

function scrollDown() {

}

var lastScrollTop = 0;

function separateScript() {
    const animate_script = document.querySelectorAll('.animate-script');
    if (animate_script) {
        for (let a = 0; a < animate_script.length; a++) {
            let this_strong = animate_script[a].querySelector('strong');
            if (this_strong) {
                let split_strong = this_strong.innerHTML.split('');
                this_strong.innerHTML = '';
                for (let s = 0; s < split_strong.length; s++) {
                    this_strong.innerHTML += `<span>${split_strong[s]}</span>`;
                }
            }
        }
    }
}

function instaSlick() {
    setTimeout(function() {
        $('.instagram_gallery').slick({
            accessibility: false,
            slidesToShow: 3
        });
    }, 2000)

}
if (typeof ig_username !== 'undefined') {
    instagramAjaxFeed(ig_username, 8, '#instagram-images', 380, '.photo-gallery', instaSlick());
}


(function() {

    $(document).ready(function() {

        // POPULATE 2ND NAV CLONES
        document.querySelectorAll('.js-secondaryNav').forEach(nav => {
            document.querySelectorAll('.secondary-navigation__item').forEach(item => nav.innerHTML += `<li>${item.innerHTML}</li>`);
        });

        //Press Download select change function
        const download_select = document.getElementById('js-download-select');
        if (download_select) {
            download_select.addEventListener('change', function() {
                const this_val = this.value;
                const gallery_groups = document.querySelectorAll('.download-gallery__group');
                for (let g = 0; g < gallery_groups.length; g++) {
                    gallery_groups[g].classList.remove('active')
                }
                document.querySelector(`.download-gallery__group[data-tag="${this_val}"]`).classList.add('active');
            })
        }


        //BG Accordion functionality

        $('.bg-accordion__bg').slick({
            accessibility: false
        })

        const bg_acc_btns = document.querySelectorAll('.ac-item__button');
        const bg_acc_items = document.querySelectorAll('.ac-item');
        if (bg_acc_btns) {
            for (let i = 0; i < bg_acc_btns.length; i++) {
                bg_acc_btns[i].addEventListener('click', function() {
                    if (this.closest('.ac-item').classList.contains('active')) {
                        this.closest('.ac-item').classList.remove('active');
                    } else {
                        for (let a = 0; a < bg_acc_items.length; a++) {
                            bg_acc_items[a].classList.remove('active');
                        }
                        this.closest('.ac-item').classList.add('active');
                        $('.bg-accordion__bg').slick('slickGoTo', i);
                    }

                })
            }
        }

        separateScript();

        //Buttons data title for hover
        const btn = document.getElementsByClassName('btn');
        if (btn) {
            for (let b = 0; b < btn.length; b++) {
                let this_html = btn[b].innerHTML;
                this_html = this_html.toString();
                this_html = this_html.replace(/<[^>]*>/g, '');
                btn[b].dataset.hover = this_html;
            }
        }

        //$('.btn').wrap('<div class="btn__wrapper"></div>')


        //Main navigation dropdown
        const nav_li = document.querySelectorAll('#privary-navigation li');
        if (nav_li) {
            for (let i = 0; i < nav_li.length; i++) {
                const this_subnav = nav_li[i].querySelector('.submenu');
                if (this_subnav) {
                    nav_li[i].classList.add('has_submenu');
                    nav_li[i].querySelector('a').addEventListener('click', function(event) {
                            event.preventDefault();
                        })
                        // nav_li[i].addEventListener('click', function(event){
                        // 	nav_li[i].classList.toggle('active');
                        // });
                }
            }
        }

        //Accordion functionality
        const acc_btns = document.querySelectorAll('.accordion__button');
        const acc_items = document.querySelectorAll('.accordion__item');
        if (acc_btns) {
            for (let i = 0; i < acc_btns.length; i++) {
                acc_btns[i].addEventListener('click', function() {
                    if (this.closest('.accordion__item').classList.contains('active')) {
                        this.closest('.accordion__item').classList.remove('active');
                    } else {
                        for (let a = 0; a < acc_items.length; a++) {
                            acc_items[a].classList.remove('active');
                        }
                        this.closest('.accordion__item').classList.add('active');
                    }
                })
            }
        }

        //Open and close Booking widget
        const open__booking = document.getElementById('js-open-booking');
        if (open__booking) {
            open__booking.addEventListener('click', function() {
                document.querySelector('.booking').classList.add('open');
            });

            const close__booking = document.getElementById('js-close-booking');
            close__booking.addEventListener('click', function() {
                document.querySelector('.booking').classList.remove('open');
            });
        }

        //Open and close Booking widget Tablet
        const open__booking_t = document.getElementById('js-open-booking-tablet');
        if (open__booking_t) {
            open__booking_t.addEventListener('click', function() {
                document.querySelector('.booking').classList.add('open');
            });

            const close__booking = document.getElementById('js-close-booking');
            close__booking && close__booking.addEventListener('click', function() {
                document.querySelector('.booking').classList.remove('open');
            });
        }

        // BOOKING TOGGLE GUESTS DROPDOWN
        if (document.querySelector('#booking-form .guests_label')) {
            document.querySelector('#booking-form .guests_label').addEventListener('click', () => {
                if (document.querySelector('#booking-form .guests_dropdown')) {
                    document.querySelector('#booking-form .guests_dropdown').classList.toggle('open');
                }
            });
        }

        //Booking increment guests
        const booking_adults = document.querySelector('#booking-form .adults');
        if (booking_adults) {
            const less = booking_adults.querySelector('.less');
            const plus = booking_adults.querySelector('.plus');
            const adults_input = booking_adults.querySelector('#adults');
            let this_input_val;
            less.addEventListener('click', function() {
                this_input_val = adults_input.value;
                if (this_input_val > 0) {
                    adults_input.value--;
                }

                if (document.querySelector('#booking-form .guests_label')) {
                    document.querySelector('#booking-form .guests_label').textContent = `${adults_input.value} Adult${Number(adults_input.value) !== 1 ? 's' : ''}`;
                }
            });

            plus.addEventListener('click', function() {
                this_input_val = adults_input.value;
                if (this_input_val < 4) {
                    adults_input.value++;
                }

                if (document.querySelector('#booking-form .guests_label')) {
                    document.querySelector('#booking-form .guests_label').textContent = `${adults_input.value} Adult${Number(adults_input.value) !== 1 ? 's' : ''}`;
                }
            });
        }
        const booking_children = document.querySelector('#booking-form .children');
        if (booking_children) {
            const less = booking_children.querySelector('.less');
            const plus = booking_children.querySelector('.plus');
            const children_input = booking_children.querySelector('#children');
            let this_input_val;
            less.addEventListener('click', function() {
                this_input_val = children_input.value;
                if (this_input_val > 0) {
                    children_input.value--;
                }
            });

            plus.addEventListener('click', function() {
                this_input_val = children_input.value;
                if (this_input_val < 4) {
                    children_input.value++;
                }
            });
        }

        //Booking hotel select
        const booking_hotels_list = document.querySelectorAll('.booking__hotels-list li');
        if (booking_hotels_list) {
            for (let l = 0; l < booking_hotels_list.length; l++) {
                booking_hotels_list[l].addEventListener('click', function() {
                    document.querySelector('.booking__hotels-list').classList.remove('active');
                    document.querySelector('.booking__fields').classList.add('active');
                    const this_id = this.dataset.id;
                    console.log(this_id);
                    const booking_form = document.getElementById('booking-form');
                    booking_form.action = this_id;

                });
            }
        }

        const booking_hotels_back = document.querySelector('.booking .btn-back');
        if (booking_hotels_back) {
            booking_hotels_back.addEventListener('click', function() {
                document.querySelector('.booking__hotels-list').classList.add('active');
                document.querySelector('.booking__fields').classList.remove('active');
            });
        }

        const animate_headline = document.getElementsByClassName('animate-headline');
        if (animate_headline) {
            setTimeout(function() {
                for (let a = 0; a < animate_headline.length; a++) {
                    animate_headline[a].classList.add('animated');
                }
            }, 500);
        }

        //const slider_tabs = document.querySelector('.bg-tabs__slider-list');

        $('.bg-tabs__content').slick({
            fade: true
        });


        $('.bg-tabs__list li').click(function() {
            const this_index = $(this).index();
            $('.bg-tabs__content').slick('slickGoTo', this_index);
        })

        $('.bg-tabs__content').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.bg-tabs__list li').removeClass('active');
            $('.bg-tabs__list li').eq(nextSlide).addClass('active');
        });


        $('.tabs-slider__content').slick({
            fade: true
        });
        $('.tabs-slider__list li').click(function() {
            const this_index = $(this).index();
            $('.tabs-slider__content').slick('slickGoTo', this_index);
        });

        $('.tabs-slider__content').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.tabs-slider__list li').removeClass('active');
            $('.tabs-slider__list li').eq(nextSlide).addClass('active');
        });



        const hotels_select = document.getElementById('js-hotel-select');
        if (hotels_select) {
            hotels_select.addEventListener('change', function() {
                const index_select = hotels_select.value;
                $('.tabs-slider__content').slick('slickGoTo', index_select);
            })
        }

        //Columns form

        const columns_form = document.querySelector('.columns-form');
        if (columns_form) {
            const form_gdpr = columns_form.querySelector('.gdpr-wrap');
            const column1 = document.createElement('div');
            column1.setAttribute('class', 'column-wrapper column1-wrapper');
            form_gdpr.insertAdjacentElement('beforebegin', column1);

            const column2 = document.createElement('div');
            column2.setAttribute('class', 'column-wrapper column2-wrapper');
            form_gdpr.insertAdjacentElement('beforebegin', column2);

            const column1_fields = columns_form.querySelectorAll('.column1');
            for (let c1 = 0; c1 < column1_fields.length; c1++) {
                column1.appendChild(column1_fields[c1]);
            }

            const column2_fields = columns_form.querySelectorAll('.column2');
            for (let c2 = 0; c2 < column2_fields.length; c2++) {
                column2.appendChild(column2_fields[c2]);
            }


        }


        //BG quadrant open form

        const open_form = document.querySelector('.js-open-form');
        if (open_form) {
            open_form.addEventListener('click', function(event) {
                event.preventDefault();
                document.getElementById('quad-form').style.display = 'block';
                var top_col = $('#quad-form').offset().top;
                $('html,body').animate({ scrollTop: top_col }, 1500);
            });

            const close_form = document.querySelector('.quad-form__close');
            close_form.addEventListener('click', function() {
                document.getElementById('quad-form').style.display = 'none';
            })
        }

        $('#id_4_366 > option:first').html('');

        const toForm = document.querySelector('#js-to-form');
        if (toForm) {
            toForm.addEventListener('click', function(event) {
                event.preventDefault();
                var top_col = $('#email-signup').offset().top;
                $('html,body').animate({ scrollTop: top_col - 500 }, 2000);
            });
        }

        //Acts when scroll down page.
        $(window).scroll(function(event) {
            scrollDown();
        });

    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        // scrollDownAction(20, 'scroll');

        setTimeout(function() {
            if ($('.rellax').length > 0) {
                var winWidth = $(window).innerWidth();
                if (winWidth > 1200) {
                    var rellax = new Rellax('.rellax');
                }
            }
        }, 100);

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

    const window_height = window.innerHeight;
    let animatedEl = document.getElementsByClassName('animate-fade-2');
    for (let i = 0; i < animatedEl.length; i++) {
        var viewportOffset = animatedEl[i].getBoundingClientRect();
        let topPos = viewportOffset.top;
        if (topPos <= window_height * 0.8) {
            animatedEl[i].classList.add('fade-in');
            setTimeout(function() {
                if (animatedEl[i].classList.contains('animate-wiggle')) {
                    animatedEl[i].classList.add('no-animation');
                }
            }, 1000)
        }
    }
}